import React from "react";
import _ from "lodash";
import glamorous from "glamorous";
import { Button } from "react-bootstrap";

import {
  getDefaultLocation,
  ADD_LOCATION_ID
} from "../locations/LocationsState";
import LocationEditForm from "./LocationEditForm";
import MapView from "../map/MapView";
import Colors from "../../styles/colors";
import Check from "react-icons/lib/fa/check-circle-o";
import { FlexDiv, FlexColDiv } from "../../styles/container-elements";
import { isFullAddressGeocodable } from "./AddressValidation";
import { geocodeAddress } from "../geocoding/geocoding";

const FlexRow = glamorous(FlexDiv)({ width: "100%" });

const Section = glamorous.section({
  display: "flex",
  flex: 0.5,
  flexDirection: "column",
  justifyContent: "space-between",
  height: "calc(100vh - 3em)",
  backgroundColor: "white"
});

const ValidationRow = ({ isValid, field }) => {
  return (
    <FlexRow style={{ marginBottom: ".25em" }}>
      <Check
        style={{
          color: isValid ? Colors.highlight.GREEN : "#e0e0e0",
          fontSize: "large"
        }}
      />
      <glamorous.Span style={{ fontSize: "small", marginLeft: ".5em" }}>
        {`Must have valid ${field}.`}
      </glamorous.Span>
    </FlexRow>
  );
};

const mergeLatLng = (existingData, lat, lng) => {
  const data = _.cloneDeep(existingData);
  _.merge(data, {
    geofence: {
      geometry: {
        coordinates: [lng, lat]
      }
    }
  });
  return data;
};

export default class LocationEditView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: getDefaultLocation(),
      isAddressValid: false,
      typingTimeout: 0
    };
  }

  setData(props) {
    const locationData = props.locations.find(l => l.id === props.locationID);

    // combine codes into a single field for editing
    if (locationData != null) {
      this.setState({ data: { ...locationData } });
      this.setState({ isAddressValid: isFullAddressGeocodable(locationData) });
    } else {
      this.setState({ data: getDefaultLocation() });
      this.setState({ isAddressValid: false });
    }
  }

  componentDidMount() {
    this.setData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setData(nextProps);
  }

  isDoneTyping() {
    return Date.now() - this.state.lastKeyTimestamp > 1000;
  }

  render() {
    const {
      locationID,
      addLocation,
      editLocation,
      deleteLocation,
      pushLocationsScreen,
      lads,
      selectedLocation,
      H,
      platform
    } = this.props;
    const { data } = this.state;

    let selectedLad = _.get(selectedLocation, "lad");
    if (selectedLad && selectedLad.id) {
      const defaultName = lads.find(
        l => Number(l.id) === Number(selectedLad.id)
      ).default_name;
      selectedLad = { ...selectedLad, default_name: defaultName };
    }

    const mapLocationData = _.isEmpty(data) ? selectedLocation : data;

    const isNameValid = _.isEmpty(data.name) ? false : data.name.length > 2;
    const isLadValid = !_.isEmpty(data.lad);
    const isCodeValid = data.code && data.code.length > 0;
    const isLocationValid = isNameValid && isLadValid && isCodeValid;
    const isAddressValid = isFullAddressGeocodable(data);
    const isNewLocation = locationID === ADD_LOCATION_ID;

    const mergeData = newData => {
      const existingData = _.cloneDeep(this.state.data);
      this.setState({
        data: _.merge(existingData, newData)
      });
    };

    const doGeocode = mergedData => {
      if (!isNewLocation) {
        return;
      }
      const geocoder = platform.getGeocodingService();
      geocodeAddress(geocoder, mergedData)
        .then(({ lat, lng }) => {
          if (!(_.isUndefined(lat) || _.isUndefined(lng))) {
            const dataWithLatLng = mergeLatLng(mergedData, lat, lng);
            this.setState({
              data: dataWithLatLng
            });
          }
        })
        .catch(err => console.error(err));
    };

    const updateField = (field, val) => {
      const mergedData = { ...data, [field]: val };
      const isAddressValid = isFullAddressGeocodable(mergedData);
      this.setState({
        isAddressValid,
        data: mergedData
      });
      if (isAddressValid) {
        if (this.state.typingTimeout) {
          clearTimeout(this.state.typingTimeout);
        }
        this.setState({
          typingTimeout: setTimeout(() => doGeocode(mergedData), 500)
        });
      }
    };

    return (
      <glamorous.Div display="flex" flexDirection="row">
        <Section
          style={{
            borderRight: "1px solid #ddd",
            position: "relative",
            overflow: "scroll",
            backgroundColor: Colors.background.LIGHT_GRAY
          }}
        >
          <FlexColDiv
            style={{
              position: "absolute",
              justifyContent: "space-between",
              minHeight: "100%",
              width: "100%"
            }}
          >
            <LocationEditForm
              data={data}
              lads={lads}
              updateField={updateField}
              H={H}
              mergeData={mergeData}
              addressIsValid={isAddressValid}
            />

            <FlexColDiv
              css={{
                backgroundColor: Colors.background.LIGHT_GRAY,
                color: Colors.text.DARK_BLUE,
                padding: "2em",
                justifyContent: "flex-end"
              }}
            >
              <ValidationRow isValid={isNameValid} field="name" />
              <ValidationRow isValid={isLadValid} field="location type" />
              <ValidationRow isValid={isCodeValid} field="location code" />
              <FlexRow
                css={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingTop: "1em"
                }}
              >
                {locationID !== ADD_LOCATION_ID && (
                  <Button
                    style={{
                      backgroundColor: Colors.highlight.RED,
                      color: "white"
                    }}
                    onClick={() => {
                      deleteLocation(locationID);
                      pushLocationsScreen();
                    }}
                  >
                    Delete Location
                  </Button>
                )}
                <div>
                  <Button
                    style={{
                      backgroundColor: "white",
                      color: Colors.background.DARK_BLUE,
                      marginRight: "0.5em"
                    }}
                    onClick={() => pushLocationsScreen()}
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{
                      backgroundColor: Colors.highlight.GREEN,
                      color: "white"
                    }}
                    disabled={!isLocationValid}
                    onClick={() => {
                      if (locationID === ADD_LOCATION_ID) {
                        addLocation(data);
                        pushLocationsScreen();
                      } else {
                        editLocation(locationID, data);
                        pushLocationsScreen();
                      }
                    }}
                  >
                    {locationID !== ADD_LOCATION_ID
                      ? "Update Location"
                      : "Add Location"}
                  </Button>
                </div>
              </FlexRow>
            </FlexColDiv>
          </FlexColDiv>
        </Section>
        <Section>
          <MapView
            {...this.props}
            selectedLocation={mapLocationData}
            mapLocations={[selectedLocation]}
            selectedLad={selectedLad}
            isDrawingGeofence
            useBoxChiclets
          />
        </Section>
      </glamorous.Div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/location-edit/LocationEditView.js